import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'
import { clientEnv } from '@retailer-platform/dashboard/env'

// Base URLs
const URL_ADMIN_SHOPPERS_ADMIN = `${URL_APP_ADMIN}/shoppers-admin`
const URL_ADMIN_SHOPPERS_ADMIN_DASHBOARD = `${URL_ADMIN_SHOPPERS_ADMIN}/dashboard`
// Generic embedded (iframe) wrapper — hosts any legacy shoppers `/admin/...` page.
const URL_ADMIN_SHOPPERS_ADMIN_LEGACY_PAGE_IFRAME = `${URL_ADMIN_SHOPPERS_ADMIN_DASHBOARD}/admin`
// The landing path follows the shape of the embedded host: prod/staging
// serves the legacy engine at the root (`https://shoppers-admin.instacart.com/shoppers`);
// local dev mounts it under `/admin` (`https://localhost:5101/admin/shoppers`).
// Keyed off the migration base URL so prod behavior is untouched while the
// sidebar link works against either host. Unset base URL => prod shape.
const isLocalAdminHost = (() => {
  try {
    return (
      new URL(clientEnv.PUBLIC_CLIENT_SHOPPER_ADMIN_MIGRATION_BASE_URL ?? '').hostname ===
      'localhost'
    )
  } catch {
    return false
  }
})()
// Concrete landing route for the L1 sidebar entry. Points at the legacy
// `shoppers` search/index page (routes.rb:176 `resources :shoppers`).
// The wildcard below still matches every drill-down (`/care/shoppers/:id`,
// `/shoppers/:id/notes`, etc.) in both mount shapes; this identifier exists
// so the nav has a concrete URL to Link to — the wildcard `/*` pattern is a
// match rule, not a navigable URL.
const URL_ADMIN_SHOPPERS_ADMIN_SHOPPERS_INDEX = `${URL_ADMIN_SHOPPERS_ADMIN_DASHBOARD}${
  isLocalAdminHost ? '/admin' : ''
}/shoppers`
const URL_ADMIN_SHOPPERS_ADMIN_DASHBOARD_WILDCARD = `${URL_ADMIN_SHOPPERS_ADMIN_DASHBOARD}/*`
export const URL_ADMIN_SHOPPERS_ADMIN_IPP_BASE = `${URL_ADMIN_SHOPPERS_ADMIN}/care`

const URL_ADMIN_SHOPPERS_ADMIN_NOT_FOUND = `${URL_ADMIN_SHOPPERS_ADMIN}/not_found`

// Milestone 1 = iframe-only routes. The native shopper-profile page and its
// legacy-fallback route identifiers were removed from the scaffold; they will
// be reintroduced when the native page work lands (see docs/shopperAdmin/
// ImplementationStep1-EmbedShopperAdminInIPP.md §A6).

export type DashRouteSet = DashRouteType<
  | 'app-admin-shoppers-admin'
  | 'app-admin-shoppers-admin-dashboard'
  | 'app-admin-shoppers-admin-dashboard-legacy'
  | 'app-admin-shoppers-admin-shoppers-index'
  | 'app-admin-shoppers-admin-dashboard-wildcard'
  | 'app-admin-shoppers-admin-not-found'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-shoppers-admin': URL_ADMIN_SHOPPERS_ADMIN,
  'app-admin-shoppers-admin-dashboard': URL_ADMIN_SHOPPERS_ADMIN_DASHBOARD,
  'app-admin-shoppers-admin-dashboard-legacy': URL_ADMIN_SHOPPERS_ADMIN_LEGACY_PAGE_IFRAME,
  'app-admin-shoppers-admin-shoppers-index': URL_ADMIN_SHOPPERS_ADMIN_SHOPPERS_INDEX,
  'app-admin-shoppers-admin-dashboard-wildcard': URL_ADMIN_SHOPPERS_ADMIN_DASHBOARD_WILDCARD,
  // @hygen:inject route-pair
  'app-admin-shoppers-admin-not-found': URL_ADMIN_SHOPPERS_ADMIN_NOT_FOUND,
}
export type DomainRouteName = keyof typeof routes
